import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, Clock } from "lucide-react";
import api from "../lib/api";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSEO } from "../hooks/useSEO";

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  useSEO(
    "Vedic Astrology Reports & Services | NAKSRA",
    "Birth chart readings, yearly forecasts, compatibility reports and life-pivot consultations — computed with classical Jyotish methods and verified by a qualified Vedic astrologer."
  );

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050507] text-[#F8F9FA]">
      <Navbar />
      <main className="mx-auto max-w-7xl px-6 py-20">
        <p className="text-xs font-medium uppercase tracking-[0.35em] text-[#D4AF37]">Reports & Services</p>
        <h1 className="mt-4 max-w-2xl font-heading text-4xl font-medium tracking-tight sm:text-5xl">
          Readings for the decisions that matter
        </h1>
        <p className="mt-6 max-w-2xl leading-relaxed text-[#A1A1AA]">
          Every report is drafted by our proprietary AI and verified line-by-line by a qualified Vedic astrologer. Full methodology included. Money-back guarantee on everything.
        </p>

        {loading ? (
          <p className="mt-20 text-[#A1A1AA]" data-testid="services-loading">Loading…</p>
        ) : (
          <div className="mt-14 grid gap-6 md:grid-cols-2" data-testid="services-grid">
            {services.map((s, i) => (
              <motion.div
                key={s.id}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                className="flex flex-col rounded-lg border border-white/10 bg-[#0C0C10] p-8 transition-colors duration-300 hover:border-[#D4AF37]/40"
                data-testid={`service-item-${s.id}`}
              >
                <p className="text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">{s.sanskrit}</p>
                <h2 className="mt-3 font-heading text-3xl font-medium">{s.name}</h2>
                <p className="mt-4 flex-1 text-sm leading-relaxed text-[#A1A1AA]">{s.description}</p>
                <div className="mt-6 flex items-center gap-2 text-xs text-[#A1A1AA]">
                  <Clock className="h-3.5 w-3.5" /> Delivered within {s.delivery_days} days
                </div>
                <div className="mt-6 flex items-center justify-between border-t border-white/10 pt-6">
                  <span className="font-heading text-4xl text-[#D4AF37]">${s.price}</span>
                  <Link
                    to={`/services/${s.id}`}
                    data-testid={`service-select-${s.id}`}
                    className="group inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-6 py-2.5 text-sm font-semibold text-black transition-colors duration-300 hover:bg-[#FBE18D] active:scale-[0.98]"
                  >
                    Get this report <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
}
